import ResizableModal from '../../../../../ui/ResizableModal'
import { Button } from '../../../../../ui'

const EditWarehouseModal = ({ actions, open, state }) => (
  <ResizableModal
    className='font-sans'
    open={open}
    onClose={actions.handleCloseEditWarehouseModal}
    width={560}
    height={420}
    minWidth={480}
    minHeight={360}
    footer={
      <>
        <Button
          onClick={actions.handleCloseEditWarehouseModal}
          className='rounded-full bg-primary text-sm uppercase text-white'
          title='CERRAR'
          disabled={actions.updateWarehouseMutation.isPending}
        />
        <Button
          type='submit'
          form='inventory-edit-warehouse-form'
          className='rounded-full bg-accent2 text-sm uppercase text-white'
          title={actions.updateWarehouseMutation.isPending ? 'GUARDANDO...' : 'GUARDAR CAMBIOS'}
          disabled={actions.updateWarehouseMutation.isPending}
        />
      </>
    }
  >
    <div className='mx-auto w-full max-w-lg'>
      <div className='mb-4 flex items-start justify-between gap-4'>
        <div>
          <p className='text-[11px] font-semibold uppercase tracking-[0.14em] text-accent2'>
            Edición individual
          </p>
          <h3 className='mt-1 text-2xl font-semibold text-slate-950'>Editar bodega</h3>
          <p className='mt-1 text-sm text-slate-600'>Actualiza el nombre y si es la bodega predeterminada.</p>
        </div>
      </div>

      <form
        id='inventory-edit-warehouse-form'
        className='space-y-4 rounded-2xl bg-white p-4 shadow-sm'
        onSubmit={actions.handleEditWarehouseSubmit}
      >
        <div>
          <label className='mb-1 block text-xs font-semibold text-slate-700'>Código</label>
          <input
            type='text'
            value={state.warehouseEditForm.code}
            readOnly
            className='w-full rounded-lg border border-gray-300 bg-slate-50 px-3 py-2 text-sm text-slate-700'
          />
        </div>

        <div>
          <label className='mb-1 block text-xs font-semibold text-slate-700'>Nombre</label>
          <input
            type='text'
            value={state.warehouseEditForm.name}
            onChange={event => state.setWarehouseEditForm(prev => ({ ...prev, name: event.target.value }))}
            className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
            placeholder='Bodega principal'
          />
        </div>

        <label className='flex items-start gap-2 rounded-lg border border-slate-200 p-3 text-sm text-slate-700'>
          <input
            type='checkbox'
            checked={state.warehouseEditForm.isDefault}
            onChange={event =>
              state.setWarehouseEditForm(prev => ({ ...prev, isDefault: event.target.checked }))
            }
            className='mt-0.5'
          />
          <span>
            <span className='block font-medium'>Bodega predeterminada</span>
            <span className='text-xs text-slate-500'>Se usará por defecto en movimientos y cargas.</span>
          </span>
        </label>
      </form>
    </div>
  </ResizableModal>
)

export default EditWarehouseModal
